module.exports = __webpack_public_path__ + "files/fee50dcf0972af340a53755f22a57165.png";